import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleXmark,
  faInfoCircle,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";
import CheckList from "../../../cpn/common/checkList";

export default function EventLogs() {
  const { lang, proxy, auth: user, functions } = useSelector((state) => state);
  const { removeVietnameseTones, normalizeString } = functions;

  const _token = localStorage.getItem("_token");
  const [logs, setLogs] = useState([]);
  const [view, setView] = useState([]);
  const [filter, setFilter] = useState({ type: "info" });
  const [showModal, setShowModal] = useState(false);
  const [titleOptions, setTitleOptions] = useState([]);
  const [isView, setIsView] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const debounceTimeout = useRef(null);

  let langItem = localStorage.getItem("lang")
    ? localStorage.getItem("lang")
    : "Vi";
  const languages = langItem.toLowerCase();
  // //console.log(_token)
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const eventType = [
    {
      id: 0,
      label: lang["log.information"],
      value: 1,
      color: "#3029F7",
      icon: faInfoCircle,
    },
    {
      id: 1,
      label: lang["log.warning"],
      value: 2,
      color: "#f3632e",
      icon: faWarning,
    },
    {
      id: 2,
      label: lang["log.error"],
      value: 3,
      color: "#FF0000",
      icon: faCircleXmark,
    },
  ];
  const typeFilterOptions = [
    { id: 0, label: lang["log.information"], value: lang["log.information"] },
    { id: 1, label: lang["log.warning"], value: lang["log.warning"] },
    { id: 2, label: lang["log.error"], value: lang["log.error"] },
  ];
  const [tableFilter, setTableFilter] = useState({
    event_type: false,
    event_title: false,
    event_description: false,
  });
  const [hotFilter, sethotFilter] = useState({
    event_type: [],
    event_title: [],
    event_description: "",
  });

  //   useEffect(() => {
  //     fetch(`${proxy()}/auth/u/${_user}`, {
  //       headers: {
  //         Authorization: _token,
  //       },
  //     })
  //       .then((res) => res.json())
  //       .then((resp) => {
  //         const { success, data } = resp;
  //         if (success) {
  //           setUser(data);
  //         }
  //       });
  //   }, [_user]);

  const MAX_RECORDS_PER_SHEET = 13;

  useEffect(() => {
    fetch(`${proxy()}/logs/${languages}`, {
      headers: {
        Authorization: _token,
      },
    })
      .then((res) => res.json())
      .then((resp) => {
        const { success, data, status, content } = resp;
        setLoading(false);
        if (success) {
          if (data != undefined && data.length > 0) {
            const dataFilter =
              user.username !== "administrator"
                ? data.filter((item) => item.create_user === user.username)
                : data;
            const formatedData = data.map((log) => {
              return { ...log, icon: eventType[log.event_type] };
            });

            setLogs(formatedData);
            setView(formatedData);
            setIsView(formatedData);
          }
        } else {
          if (!user) {
            window.location = "/login";
          }
        }
      });
  }, []);

  const [logDetail, setLogDetail] = useState([]);

  const detailLogs = async (logid) => {
    // //console.log(logid)
    setLogDetail(logid);
  };

  const submitFilter = (e) => {
    e.preventDefault();
    filter["lang"] = languages;
    fetch(`${proxy}/logs/search`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${_token}`,
      },
      body: JSON.stringify(filter),
    })
      .then((res) => res && res.json())
      .then((resp) => {
        if (resp) {
          const { success, content, data, status } = resp;
          // //console.log(resp)
          if (success) {
            setView(data);
            // window.location.reload();
            setShowModal(false);
          } else {
            Swal.fire({
              title: "Thất bại!",
              text: content,
              icon: "error",
              showConfirmButton: false,
              timer: 2000,
            });
          }
        }
      });
  };

  const [currentPageLogs, setCurrentPageLogs] = useState(1);
  const rowsPerPageLogs = 17;
  const indexOfLastMemberLogs = currentPageLogs * rowsPerPageLogs;
  const indexOfFirstMemberLogs = indexOfLastMemberLogs - rowsPerPageLogs;
  const currentMembersLogs = view.slice(
    indexOfFirstMemberLogs,
    indexOfLastMemberLogs
  );

  const paginateLogs = (pageNumber) => setCurrentPageLogs(pageNumber);
  const totalPagesLogs = Math.ceil(view.length / rowsPerPageLogs);

  function openModalWithContent(jsonContent) {
    // Định dạng JSON để hiển thị đẹp hơn
    const formattedJson = JSON.stringify(jsonContent, null, 4);
  }
  const addOrRemoveEventType = (item) => {
    const { value } = item;
    let primalValue = value ? value : " ";
    if (typeof value != "string") {
      primalValue = primalValue.toString();
    }
    const formatedItem = {
      ...item,
      formated_value: removeVietnameseTones(primalValue.toLowerCase()),
    };
    const { event_type } = hotFilter;
    let newEventTypes = [];
    const setDataFunction = event_type.find(
      (filter) => filter.id == formatedItem.id
    );
    if (setDataFunction) {
      newEventTypes = event_type.filter(
        (filter) => filter.id != formatedItem.id
      );
    } else {
      newEventTypes = [...event_type, formatedItem];
    }
    hotFilter.event_type = newEventTypes;
    sethotFilter({ ...hotFilter, event_type: newEventTypes });
  };

  const addOrRemoveEventTitle = (item) => {
    const { value } = item;
    let primalValue = value ? value : " ";
    if (typeof value != "string") {
      primalValue = primalValue.toString();
    }
    const formatedItem = {
      ...item,
      formated_value: removeVietnameseTones(primalValue.toLowerCase()),
    };
    const { event_title } = hotFilter;
    let newEventTitles = [];
    const setDataFunction = event_title.find(
      (filter) => filter.id == formatedItem.id
    );
    if (setDataFunction) {
      newEventTitles = event_title.filter(
        (filter) => filter.id != formatedItem.id
      );
    } else {
      newEventTitles = [...event_title, formatedItem];
    }

    sethotFilter({ ...hotFilter, event_title: newEventTitles });
  };

  useEffect(() => {
    if (logs.length > 0) {
      const titles = logs.map((log) => log.event_title);
      const filtedTitles = titles.filter((item, index) => {
        return titles.indexOf(item) == index;
      });
      const formatedTitleOptions = filtedTitles.map((item, index) => {
        return { id: index, value: item, label: item };
      });
      setTitleOptions(formatedTitleOptions);
    }
  }, [logs]);

  useEffect(() => {
    const { event_type, event_title, event_description } = hotFilter;

    // console.log( hotFilter )
    if (
      event_type.length > 0 ||
      event_title.length > 0 ||
      event_description.length > 0
    ) {
      const types = event_type.map((type) => type.value);
      const titles = event_title.map((title) => title.value);
      const formatedDescription = removeVietnameseTones(
        event_description.toLowerCase()
      );
      const newData = logs
        .filter((log) => {
          if (types.length > 0) {
            return types.indexOf(log.event_type) != -1;
          } else {
            return true;
          }
        })
        .filter((log) => {
          if (titles.length > 0) {
            return titles.indexOf(log.event_title) != -1;
          } else {
            return true;
          }
        })
        .filter((log) => {
          if (event_description.length > 0) {
            const removeTones = removeVietnameseTones(
              log.event_description?.toLowerCase()
            );
            return removeTones.includes(formatedDescription);
          } else {
            return true;
          }
        });
      setView(newData);
      //   setTotalPages(Math.ceil(newData.length / MAX_RECORDS_PER_SHEET));
      // setCurrentPage(1)
    } else {
      setView(logs);
      //   setTotalPages(Math.ceil(logs.length / MAX_RECORDS_PER_SHEET));
      // setCurrentPage(1)
    }
  }, [hotFilter]);
  const handleChange = (e) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      const str = normalizeString(e.target.value.trim());

      setView((prev) => {
        const newView = [...prev];
        const filterView = newView.filter((item) => {
          const plainTitle = normalizeString(item?.event_title);
          const plainType = normalizeString(item?.event_type);

          const plainDescr = normalizeString(item?.event_description);
          return (
            plainType.includes(str) ||
            plainTitle.includes(str) ||
            plainDescr.includes(str) ||
            item.create_at.includes(str)
          );
        });

        if (str == "") {
          setView(isView);
        }
        if (filterView) {
          return filterView;
        }
      });
    }, 1000);
  };

  return (
    <div class="midde_cont">
      <div class="container-fluid">
        <div class="row column_title">
          <div class="col-md-12">
            <div class="page_title">
              <h4>{lang["log.title"]}</h4>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="white_shd full margin_bottom_30">
              <div
                class="full graph_head"
                style={{
                  borderBottom: "1px solid rgb(221, 221, 221)",
                }}
              >
                <div class="heading1 margin_0">
                  <h5>{lang["log.listlog"]}</h5>
                </div>
              </div>
              <div
                class="table_section padding_infor_info"
                style={{
                  padding: "6px 12px",
                }}
              >
                <div
                  class="table-responsive table-custom"
                  style={{ minHeight: "78vh", position: "relative" }}
                >
                  <table class="table bordered">
                    <thead>
                      <tr>
                        <td>{lang["log.no"]}</td>
                        <th class="align-center">
                          <div
                            className="d-flex align-items-center"
                            onClick={() => {
                              setTableFilter({
                                event_type: !tableFilter.event_type,
                              });
                            }}
                          >
                            <span className="font-weight-bold">
                              {lang["log.type"]}
                            </span>
                            <i className="fa fa-filter icon-view block ml-auto" />
                          </div>
                          {tableFilter.event_type && (
                            <div className="position-relative">
                              <div
                                className="position-absolute shadow"
                                style={{ top: 0, left: -8, width: "150px" }}
                              >
                                <CheckList
                                  title={lang["log.type"]}
                                  initialData={hotFilter.event_type}
                                  setDataFunction={addOrRemoveEventType}
                                  data={typeFilterOptions}
                                  destructFunction={() => {
                                    setTableFilter({
                                      ...tableFilter,
                                      event_type: false,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </th>
                        <th>
                          {/* {lang["log.listtitle"]} */}
                          <div
                            className="d-flex align-items-center"
                            onClick={() => {
                              setTableFilter({
                                event_title: !tableFilter.event_title,
                              });
                            }}
                          >
                            <span className="font-weight-bold">
                              {lang["log.listtitle"]}
                            </span>
                            <i className="fa fa-filter icon-view block ml-auto" />
                          </div>
                          {tableFilter.event_title && (
                            <div className="position-relative">
                              <div
                                className="position-absolute shadow"
                                style={{ top: 0, left: -8, width: "150px" }}
                              >
                                <CheckList
                                  title={lang["log.listtitle"]}
                                  initialData={hotFilter.event_title}
                                  setDataFunction={addOrRemoveEventTitle}
                                  data={titleOptions}
                                  destructFunction={() => {
                                    setTableFilter({
                                      ...tableFilter,
                                      event_title: false,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </th>
                        <td>{lang["description"]}</td>
                        <td>{lang["time"]}</td>
                        <td class="align-center">{lang["log.action"]}</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="header-cell search">
                        <td></td>
                        <td>
                          {/* <input
                              className="form-control"
                              type="search"
                              onChange={handleChange}
                            /> */}
                        </td>
                        <td>
                          <input
                            className="form-control"
                            type="search"
                            onChange={handleChange}
                          />
                        </td>
                        <td>
                          <input
                            className="form-control"
                            type="search"
                            onChange={handleChange}
                          />
                        </td>
                        <td>
                          <input
                            className="form-control"
                            type="search"
                            onChange={handleChange}
                          />
                        </td>
                      </tr>
                      {view && view.length > 0 ? (
                        <>
                          {currentMembersLogs.map((log, index) => {
                            // Tìm kiểu sự kiện tương ứng trong mảng eventType
                            const event = eventType.find(
                              (item) => item.label === log.event_type
                            );

                            return (
                              <tr
                                key={"id" + indexOfFirstMemberLogs + index + 1}
                              >
                                <td style={{ width: "50px" }}>
                                  {indexOfFirstMemberLogs + index + 1}
                                </td>

                                <td
                                  class="align-center"
                                  style={{ width: "100px" }}
                                >
                                  {event && (
                                    <>
                                      <FontAwesomeIcon
                                        icon={event.icon}
                                        style={{
                                          color: event.color,
                                          fontSize: "20px",
                                        }}
                                      />
                                      {/* <i
                                            class={`${event.icon}`}
                                            style={{ color: event.color }}
                                            title={event.label}
                                          ></i> */}
                                    </>
                                  )}
                                </td>
                                <td style={{ width: "160px" }}>
                                  {log.event_title}
                                </td>
                                <td class="cell-log">
                                  {log.event_description}
                                </td>
                                <td
                                  class="align-center"
                                  style={{ width: "180px" }}
                                >
                                  {log.create_at}
                                </td>
                                <td
                                  class="align-center"
                                  style={{ width: "80px" }}
                                >
                                  <i
                                    class="fa fa-eye size pointer icon-margin size-24 icon-view"
                                    onClick={() => detailLogs(log)}
                                    data-toggle="modal"
                                    data-target="#viewLog"
                                    style={{ color: "green" }}
                                    title={lang["btn.viewdetail"]}
                                  ></i>
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      ) : (
                        <tr>
                          <td colspan={`7`} style={{ textAlign: "center" }}>
                            {isLoading ? (
                              <img
                                width={35}
                                className="mb-1"
                                src="/images/icon/load.gif"
                                alt="Loading..."
                              ></img>
                            ) : (
                              lang["log.notfound"]
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div
                    className="d-flex justify-content-between align-items-center position-absolute"
                    style={{ bottom: "15px", right: "0", width: "100%" }}
                  >
                    <p>
                      {lang["show"]} {indexOfFirstMemberLogs + 1}-
                      {Math.min(indexOfLastMemberLogs, logs.length)}{" "}
                      {lang["of"]} {view.length} {lang["results"]}
                    </p>
                    <nav aria-label="Page navigation example">
                      <ul className="pagination mb-0">
                        <li
                          className={`page-item ${
                            currentPageLogs === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => paginateLogs(1)}
                          >
                            &#8810;
                          </button>
                        </li>
                        <li
                          className={`page-item ${
                            currentPageLogs === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => paginateLogs(currentPageLogs - 1)}
                          >
                            &laquo;
                          </button>
                        </li>
                        {currentPageLogs > 3 && (
                          <li className="page-item">
                            <span className="page-link">...</span>
                          </li>
                        )}
                        {Array(totalPagesLogs)
                          .fill()
                          .map((_, index) => {
                            if (
                              index + 1 === currentPageLogs ||
                              (index + 1 >= currentPageLogs - 5 &&
                                index + 1 <= currentPageLogs + 5)
                            ) {
                              return (
                                <li
                                  key={index}
                                  className={`page-item ${
                                    currentPageLogs === index + 1
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => paginateLogs(index + 1)}
                                  >
                                    {index + 1}
                                  </button>
                                </li>
                              );
                            }
                          })}
                        {currentPageLogs < totalPagesLogs - 2 && (
                          <li className="page-item">
                            <span className="page-link">...</span>
                          </li>
                        )}
                        <li
                          className={`page-item ${
                            currentPageLogs === totalPagesLogs ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => paginateLogs(currentPageLogs + 1)}
                          >
                            &raquo;
                          </button>
                        </li>
                        <li
                          className={`page-item ${
                            currentPageLogs === totalPagesLogs ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => paginateLogs(totalPagesLogs)}
                          >
                            &#8811;
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* View log */}
        <div
          class={`modal no-select-modal ${showModal ? "show" : ""}`}
          id="viewLog"
        >
          <div class="modal-dialog modal-dialog-center">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{lang["detaillog"]}</h4>
                <button
                  type="button"
                  class="close"
                  onClick={handleCloseModal}
                  data-dismiss="modal"
                >
                  &times;
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="row">
                    <div class="form-group col-lg-6">
                      <label>
                        <b>{lang["log.id"]}</b>
                      </label>
                      <span className="d-block">{logDetail.event_id} </span>
                    </div>
                    <div class="form-group col-lg-6">
                      <label>
                        <b>{lang["log.type"]}</b>{" "}
                      </label>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {(() => {
                          const event = eventType.find(
                            (item) => item.label === logDetail.event_type
                          );
                          return (
                            event && (
                              <i
                                className={` ${event.icon}`}
                                style={{ color: event.color }}
                                title={event.label}
                              ></i>
                            )
                          );
                        })()}
                        <span className="ml-1"> {logDetail.event_type}</span>
                      </div>
                    </div>
                    <div class="form-group col-lg-12">
                      <label>
                        <b>{lang["log.listtitle"]}</b>
                      </label>
                      <span className="d-block">{logDetail.event_title} </span>
                    </div>
                    <div class="form-group col-lg-12">
                      <label>
                        <b>{lang["description"]}</b>
                      </label>
                      <span className="d-block">
                        {logDetail.event_title === "Import devices' json" ? (
                          <pre>
                            {JSON.stringify(
                              JSON.parse(logDetail.event_description),
                              null,
                              4
                            )}
                          </pre>
                        ) : (
                          logDetail.event_description
                        )}
                      </span>
                    </div>

                    <div class="form-group col-lg-4 col-sm-12">
                      <label>
                        <b>{lang["log.create_user"]} </b>
                      </label>
                      <span className="d-block">{logDetail.create_user} </span>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12">
                      <label>
                        <b>{lang["log.create_at"]}</b>{" "}
                      </label>
                      <span className="d-block">{logDetail.create_at} </span>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12">
                      <label>
                        <b>IP:</b>
                      </label>

                      {(() => {
                        if (logDetail.ip) {
                          let ipString = logDetail.ip;
                          let ipParts = ipString.split("::ffff:");
                          let ipAddress =
                            ipParts.length > 1 ? ipParts[1] : ipParts[0];
                          console.log("ipAddress", currentMembersLogs);
                          return <span className="d-block">{ipAddress}</span>;
                        }
                        return null; // Hoặc bạn có thể trả về một giá trị mặc định hoặc một thành phần khác tại đây
                      })()}
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  onClick={handleCloseModal}
                  data-dismiss="modal"
                  class="btn btn-danger"
                >
                  {lang["btn.close"]}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
